export const PARTICIPANTSMODAL = 'PARTICIPANTSMODAL';
export const SITUATIONSMODAL = 'SITUATIONSMODAL';
